import { TemplateModel } from "./TemplateModel";
import { Expose } from "class-transformer";
import { ResponseType } from "./Enums/ResponseType";

export class Startup {
  @Expose({ name: "listTitle" })
  ListTitle: string;

  @Expose({ name: "listParagraphOne" })
  ListParagraphOne: string;

  @Expose({ name: "listParagraphTwo" })
  ListParagraphTwo: string;

  @Expose({ name: "templateId" })
  TemplateId: string;

  @Expose({ name: "templateInformation" })
  TemplateInformation: TemplateModel;

  @Expose({ name: "referrerTypeId" })
  ReferrerTypeId: ResponseType;

  @Expose({ name: "referrerId" })
  ReferrerId: string;

  @Expose({ name: "rubReferrerDetailId" })
  SubReferrerDetailId?: string;

  constructor(
    listTitle: string,
    listParagraphOne: string,
    listParagraphTwo: string,
    templateId: string,
    templateInformation: TemplateModel,
    referrerId: ResponseType,
    referrerDetailId: string,
    subReferrerDetailId: string
  ) {
    this.ListTitle = listTitle;
    this.ListParagraphOne = listParagraphOne;
    this.ListParagraphTwo = listParagraphTwo;
    this.TemplateId = templateId;
    this.TemplateInformation = templateInformation;
    this.ReferrerTypeId = referrerId;
    this.ReferrerId = referrerDetailId;
    this.SubReferrerDetailId = subReferrerDetailId;
  }
}
